import React from "react";
import { Container, Group } from "@mantine/core";
import { DimmedText } from "../UI/Typography";

/**
 * SiteFooter - In-flow site footer rendered at the bottom of PageShell.
 *
 * NOT fixed — scrolls into view naturally at the end of the page.
 * Frees ~60px of viewport that the old fixed AppShell.Footer was eating
 * on every screen.
 */
export const SiteFooter: React.FC = () => (
  <Container
    size="xl"
    py="lg"
    style={{
      position: "relative",
      zIndex: 2,
      borderTop: "1px solid rgba(212, 85, 43, 0.12)",
      marginTop: "clamp(60px, 8vw, 96px)",
    }}
  >
    <Group justify="space-between" align="center" wrap="wrap" gap="md">
      <DimmedText size="sm">
        &copy; {new Date().getFullYear()} Ogarocious
      </DimmedText>
      <DimmedText size="xs">Built with React, Rails &amp; Mantine</DimmedText>
    </Group>
  </Container>
);

export default SiteFooter;
